import { matchPath, useLocation } from "react-router-dom";

import { PATHS } from "@/constants/paths";

// NOTE: NSAI-7288 — the meeting page ends in the recording play bar, whose far
// end holds the speed and download controls, right where the shell overlays
// its corner copyright. The layout asks this to keep the two apart.
export const useIsMeetingDetailsRoute = (): boolean => {
  const { pathname } = useLocation();

  return matchPath(PATHS.MEETING_DETAILS, pathname) !== null;
};
